import React, { useState } from "react";
import styled from "styled-components";
import theme from "../../../assets/theme";
import COLORS from "../../../assets/Colors";
import Drawer from "../../common/Drawer/AgentListDrawerModal";
import { Heading } from "../../../styles/component/style";
import CustomTable from "../../common/CustomTable/CustomTable";
import { Tooltip } from "@material-ui/core";
import Accordion from "@material-ui/core/ExpansionPanel";
import AccordionSummary from "@material-ui/core/ExpansionPanelSummary";
import AccordionDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import _ from "lodash";
import { PrimaryCTAButton } from "../Buttons";
import MultipleSelectedCaseModal from "./MultipleCaseModal";

const Index = ({
  opendrawer,
  setOpenDrawer,
  MTRef,
  partyList,
  displayAuthUrl,
}) => {
  return (
    <Drawer state={opendrawer} setState={setOpenDrawer} label="Agent Details">
      <Container>
        <Header>
          <Heading>Counsel Details</Heading>
          <CloseButton onClick={() => setOpenDrawer(false)}>
            <img
              src={require("../../../assets/images/closeModal.svg")}
              alt="close"
            />
          </CloseButton>
        </Header>

        <AccordionContainer>
          {partyList?.map((item, index) => (
            <AgentAccordion
              key={index}
              title={
                item?.partyRole
                  ? `${item?.party?.name}'s Agents (${_.capitalize(
                      item.partyRole
                    )})`
                  : `${item?.party?.name}'s Agents`
              }
              agents={item?.party?.agents || []}
              MTRef={MTRef}
              displayAuthUrl={displayAuthUrl}
            />
          ))}
        </AccordionContainer>
      </Container>
    </Drawer>
  );
};

export default Index;

// Individual Accordion Component
const AgentAccordion = ({ title, agents, MTRef, displayAuthUrl }) => {
  const [modal, setModal] = useState({ state: false });

  const columns = [
    {
      field: "user.name",
      title: "Counsel Name",
      width: "28%",
      sorting: false,
      render: (rowData) => (
        <NameCell>
          <span>{rowData?.user?.name || "-"}</span>
          {rowData?.role === "primary" && (
            <Tooltip title="Primary Counsel" placement="top">
              <RoleContainer>{"℗"}</RoleContainer>
            </Tooltip>
          )}
        </NameCell>
      ),
    },
    {
      field: "email",
      title: "Email",
      width: "30%",
      sorting: false,
      render: (rowData) => (
        <EmailCell>
          <a href={`mailto:${rowData.email}`}>{rowData.user.email || "-"}</a>
        </EmailCell>
      ),
    },
    {
      field: "user.mobile",
      title: "Phone",
      width: "20%",
      sorting: false,
      render: (rowData) => <PhoneCell>{rowData.user?.mobile || "-"}</PhoneCell>,
    },
    {
      field: "assignedCases",
      title: "Assigned Cases",
      width: "22%",
      sorting: false,
      render: (rowData) => (
        <ActionCell>
          <PrimaryCTAButton
            onClick={() => setModal({ state: true, data: rowData })}
            style={{ padding: "8px 16px", fontSize: "13px" }}
          >
            View Cases
          </PrimaryCTAButton>
        </ActionCell>
      ),
    },
  ];

  return (
    <>
      <StyledAccordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon style={{ color: "#00838c" }} />}
        >
          <AccordionTitle>{title}</AccordionTitle>
        </AccordionSummary>
        <AccordionDetails>
          <TableWrapper>
            {agents.length > 0 ? (
              <CustomTable
                columns={columns}
                data={agents}
                MTRef={MTRef}
                noToolbar
                pageSize={100}
                hidePagination
                state={{ data: agents }}
              />
            ) : (
              <EmptyState>No agents assigned</EmptyState>
            )}
          </TableWrapper>
        </AccordionDetails>
      </StyledAccordion>

      {modal.state && (
        <MultipleSelectedCaseModal modal={modal} setModal={setModal} />
      )}
    </>
  );
};

/* BEAUTIFUL & PERFECTLY ALIGNED STYLES */

const Container = styled.div`
  background-color: #f9f9fc;
  min-height: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 32px;
  background: white;
  border-bottom: 1px solid #e1e3ee;
  position: sticky;
  top: 0;
  z-index: 10;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  border-radius: 50%;
  transition: background 0.2s;

  &:hover {
    background: #f0f0f0;
  }

  img {
    width: 16px;
    height: 16px;
  }
`;

const AccordionContainer = styled.div`
  padding: 16px 20px;
`;

const StyledAccordion = styled(Accordion)`
  && {
    margin: 12px 0 !important;
    border-radius: 12px !important;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08) !important;
    border: 1px solid #e1e3ee;

    &::before {
      display: none;
    }
  }
`;

const AccordionTitle = styled.div`
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 16px;
  color: ${COLORS.COLOR_DARK};
  font-weight: 600;
  margin-left: 10px;
`;

const TableWrapper = styled.div`
  padding: 8px 0;
  background: white;
`;

// Perfectly Aligned Table Cells
const NameCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
    display: inline-block;
  }
`;

const EmailCell = styled.div`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 14px;

  a {
    color: inherit;
    text-decoration: none;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    max-width: 100%;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const PhoneCell = styled.div`
  font-family: ${theme.fonts.primaryFontRegular};
  font-size: 14px;
  color: ${COLORS.COLOR_DARK};
`;

const ActionCell = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #666;
  font-family: ${theme.fonts.primaryFontSemiBold};
  font-size: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 16px;
`;

/* Optional: Add to your CustomTable global styles */
export const TableFixStyles = `
  .MuiTableCell-root {
    padding: 12px 16px !important;
    font-size: 14px !important;
  }
  .MuiTableCell-head {
    background-color: #f8f9fa !important;
    font-family: ${theme.fonts.primaryFontSemiBold} !important;
    color: #5a7184 !important;
    font-size: 12px !important;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .MuiTableRow-root:hover {
    background-color: #f8fbfe !important;
  }
`;

export const RoleContainer = styled.p`
  color: ${COLORS.COLOR_DARK};
  font-size: 14px;
  font-family: ${theme.fonts.primaryFontBold};
  margin-left: 3px;
`;
